import React from 'react'
import { styled } from '@mui/material/styles'
import { Helmet } from '@dr.pogodin/react-helmet'

import { Paper, Typography } from '@mui/material'

import SignInComponent from '../../components/auth/SignIn'
import { useTranslation } from 'react-i18next'

const Wrapper = styled(Paper)`
    padding: ${(props) => props.theme.spacing(6)};

    ${(props) => props.theme.breakpoints.up('md')} {
        padding: ${(props) => props.theme.spacing(10)};
    }
`

function SignIn() {
    const { t } = useTranslation()
    return (
        <React.Fragment>
            <Wrapper>
                <Helmet title={t('pages.auth.signIn.helmetTitle')} />
                <Typography component='h2' variant='body1' align='center'>
                    {t('site.auth.loginPrompt')}
                </Typography>

                <SignInComponent />
            </Wrapper>
        </React.Fragment>
    )
}

export default SignIn
